import { api } from './auth.service';

const valorService = {

  // Lista valores de um cadastro específico
  listar: async (vinculo, idVinculo) => {
    const res = await api.get(`/valores/${vinculo}/${idVinculo}`);
    return res.data;
  },

  // Inclui novo valor e atualiza o cadastro vinculado
  incluir: async (dados) => {
    const res = await api.post('/valores', dados);
    return res.data;
  },

  alterar: async (id, dados) => {
    const res = await api.put(`/valores/${id}`, dados);
    return res.data;
  },

  excluir: async (id) => {
    const res = await api.delete(`/valores/${id}`);
    return res.data;
  },
};

export default valorService;
